"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Diligent___StyledSvg",
  componentId: "sc-1cznoef-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Diligent(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 74 80",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M0 80h29.59c2.924 0 6.866-.133 9.214-.443 7.486-.975 12.935-3.41 17.231-5.892 4.209-2.436 9.258-6.821 12.935-13.377L50.454 27.154 0 80z",
    fill: "#921A1D"
  }), _react["default"].createElement("path", {
    d: "M57.497 7.22C49.568 1.905 39.601 0 31.85 0H0l50.41 27.11 14.53-13.29a38.281 38.281 0 00-7.443-6.6z",
    fill: "#EE312E"
  }), _react["default"].createElement("path", {
    d: "M68.97 60.288c2.968-5.316 5.006-12.049 5.006-20.288 0-11.473-3.81-20.022-9.037-26.135L50.41 27.154 68.97 60.288z",
    fill: "#AF292E"
  }), _react["default"].createElement("path", {
    d: "M0 0v80l50.454-52.89L0 0z",
    fill: "#D3222A"
  }));
}

var _default = Diligent;
exports["default"] = _default;